import React, { useContext } from 'react'
import {
    StyledActionCard,
    StyledAppDownloadImg,
    StyledButtonGroup,
    StyledDescription,
    StyledHeading,
    StyledLinkButton,
    StyledRow,
    StyledTNAppDownloadCard,
    StyledTNLogoWrapper,
} from './TNAppDownloadCard.styled'
import { Arrow } from './assets/Arrow'
import { AppIcon } from './assets/AppIcon'
import { ConfigurationContext } from '@news-mono/web-common'
import { IconDownloadAppStore, IconDownloadPlayStore } from '../../icons'

const ActionCard: React.FC = () => {
    const config = useContext(ConfigurationContext)

    return (
        <StyledActionCard>
            <StyledRow>
                <Arrow logoWidth={72} logoHeight={36} />
                <StyledTNLogoWrapper>
                    <AppIcon />
                </StyledTNLogoWrapper>
            </StyledRow>
            <StyledHeading>The Nightly App</StyledHeading>
            <StyledDescription>
                <strong>News. As it is.</strong>  Free to your device.<br></br>
                Available for iOS and Android.
            </StyledDescription>
            <StyledButtonGroup>
                <StyledLinkButton to={config.appDownloadUrlApple ?? '#'}>
                    <IconDownloadAppStore />
                </StyledLinkButton>
                <StyledLinkButton to={config.appDownloadUrlGoogle ?? '#'}>
                    <IconDownloadPlayStore />
                </StyledLinkButton>
            </StyledButtonGroup>
        </StyledActionCard>
    )
}

export const TNAppDownloadCard: React.FC = () => {
    const mobileImage = require('./assets/thenightly-app-download-1.webp')
    const mobileImage2 = require('./assets/thenightly-app-download-2.webp')

    return (
        <StyledTNAppDownloadCard>
            <ActionCard />
            <StyledAppDownloadImg
                src={mobileImage}
                alt="Download The Nightly Mobile App"
            />
            <StyledAppDownloadImg
                src={mobileImage2}
                alt="Download The Nightly Mobile App"
            />
        </StyledTNAppDownloadCard>
    )
}
